import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import Loader from 'halogen/PulseLoader';
import { injectIntl, intlShape } from 'react-intl';
import css from '../index.scss';
import messages from '../messages';
import EmptyState from '../../empty-state/index';
import ViewCourse from '../../view-course/index';
import * as actionTypes from '../../../containers/manage-assigned-courses/action-types';

const SelectCourse = (props) => {
    const { intl,
        filteredCourses,
        handleOnCourseSelection,
        isProductCoursesLoaded,
        initialLoad,
        dispatch,
        forLegacy } = props;

    function displayCourses() {
        if (!isProductCoursesLoaded && !initialLoad) {
            return (
                <div className={css.loader}>
                    <Loader color="grey" size="15px" />
                </div>
            );
        }

        if (!filteredCourses.length) {
            return (
                <div className={css.empty}>
                    <EmptyState message={intl.formatMessage(messages.noCoursesFound)} />
                </div>
            );
        }

        return filteredCourses.map(course => (
            <div className={css.courseRow} key={`row_${course.id}`}>
                <button
                    className={course.isSelected ? css.courseSelected : css.course}
                    key={course.id}
                    onClick={() => handleOnCourseSelection({ id: course.id, name: course.name })}>{course.name}
                </button>
                { forLegacy && <ViewCourse handleOnClick={() => dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: course.id })} />}
            </div>));
    }

    return (
        <div className={css.selectCourseContainer}>
            <div className={css.courseHeader}>{intl.formatMessage(messages.selectCourse).toUpperCase()}</div>
            <div className={css.selectCourse}>
                {displayCourses()}
            </div>
        </div>
    );
};

SelectCourse.propTypes = {
    intl: intlShape.isRequired,
    filteredCourses: PropTypes.array,
    handleOnCourseSelection: PropTypes.func,
    isProductCoursesLoaded: PropTypes.bool,
    initialLoad: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    forLegacy: PropTypes.bool
};

export default injectIntl(styleable(css)(SelectCourse));



// WEBPACK FOOTER //
// ./app/components/assign-course-upf/pages/select-course.js